import React, { useState, useRef, useEffect, useContext } from 'react'
import mobiscroll from '@mobiscroll/react'
import * as m5 from '@mobiscroll/react5'
import firebase from 'firebase/app'
import { auth, db } from '../index'
import Nav from './Nav'
import { QA } from './QA'
import dealersOptions from '../dataset/dealers.json'
import { version } from '../../package.json'
import { AppContext } from '../Launcher'
import { getTimestamp } from '../Helper'
import DividendCalendar from './DividendCalendar'
import DealerEditor from './DealerEditor'

export const CONFIG_REVENUE = "config_revenue"
export const displayRevenueOption = [
    {
        text: '忽略賣出費用',
        value: 'def',
    },
    {
        text: '預扣賣出費用',
        value: 'pre'
    }
]

export const configPrice = "config_price"
export const displayPriceOption = [
    {
        text: '買入均價',
        value: 'buyin',
    },
    {
        text: '成本均價',
        value: 'cost'
    }
]

export const configCols = "config_cols"
export const displayColsOption = [
    {
        text: '預設',
        value: 'def',
        cols: [
            ['id'],
            ['holdQ', 'price'],
            ['marketCap', 'pz'],
            ['revenue', 'roi']
        ]
    },
    {
        text: '詳細(含成本)',
        value: 'adv',
        cols: [
            ['name', 'holdQ'],
            ['pz', 'price'],
            ['marketCap', 'totalCost'],
            ['revenue', 'roi']
        ]
    }
]

export const configMultiSync = "config_multi_sync"

let info = [
    { id: 1, title: '推薦給好朋友', des: '' },
    { id: 2, title: '評價及回饋', des: '' },
    { id: 3, title: '版本', des: version },
    { id: 4, title: '常見問題', des: '' }
]

if (window.Stockbook) {
    info.splice(0, 0, { id: 0, title: '支持開發', des: '' })
}

if (window.Stockbook && window.Stockbook.upgrade) {
    info.splice(0, 0, { id: -1, title: '完整版記帳本', des: '' })
}

const dealersLimit = 5
const upgradeAppUrl = 'https://play.google.com/store/apps/details?id=com.ltstudio.stockbook'
const subscriptionUrl = 'https://play.google.com/store/account/subscriptions'

export const UpgradePage = ({ theme, onClose, userId, isAnonymous }) => {
    const txt = theme === 'dark' ? 'text-light' : 'text-dark'
    const transferCode = userId || ''
    const copyTransferCode = () => {
        if (!transferCode) return

        navigator.clipboard.writeText(transferCode).then(() => {
            mobiscroll.toast({
                message: '複製成功'
            })
        }, (err) => {
            console.error('', err)
        })

        if (window.Stockbook && typeof window.Stockbook.copy === 'function') {
            window.Stockbook.copy(transferCode)
        }
    }

    return (
        <>
            <Nav theme={theme} title="完整版記帳本" onBack={onClose} />
            <m5.Page className={txt + ' sb-page-no-safe-top'}>
                <div className='w-100 h-100 d-flex flex-column text-center px-4' style={{ paddingTop: '5rem' }}>
                    <div className='d-flex flex-column justify-content-center align-items-center flex-grow-1'>
                        <div className='d-flex justify-content-center align-items-center mx-auto mb-3' style={{ width: 128, height: 128 }}>
                            <img
                                src='/img/newlogo512.png'
                                alt='新版 App Icon'
                                style={{ width: 108, height: 108, borderRadius: 24, objectFit: 'cover' }}
                            />
                        </div>
                        <h4 className='mb-3'>完整版記帳本</h4>
                        <div className='text-muted'>新版有更完整的功能並持續增加新功能🎉🎉</div>
                        <div className='text-muted mt-2'>請使用新版記帳本以獲得完整體驗。</div>
                        <div className='mt-4 d-flex justify-content-center'>
                            <a rel='noreferrer' href={upgradeAppUrl} target='_blank' className='btn btn-primary text-white'>
                                前往 Google Play
                            </a>
                        </div>
                        {isAnonymous && transferCode && (
                            <div className='mt-4 w-100 text-left border rounded p-3' style={{ maxWidth: 420 }}>
                                <div className='d-flex align-items-center justify-content-between mb-2'>
                                    <div className='font-weight-bold'>匿名使用者代碼</div>
                                    <button
                                        type='button'
                                        className='btn btn-link p-0 text-primary'
                                        aria-label='複製代碼'
                                        onClick={copyTransferCode}
                                    >
                                        <i className='bi bi-clipboard' style={{ fontSize: '1.2rem' }} />
                                    </button>
                                </div>
                                <div className='mb-2 text-break' style={{ wordBreak: 'break-all' }}>{transferCode}</div>
                                <div className='text-muted' style={{ fontSize: '0.85rem', lineHeight: 1.6 }}>
                                    請在新版輸入此代碼，轉移資料。
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </m5.Page>
        </>
    )
}

const VIPPage = ({ theme, onClose, vip }) => {
    const isVip = !!vip
    const txt = theme === 'dark' ? 'text-light' : 'text-dark'

    return (
        <>
            <Nav theme={theme} title="支持開發" onBack={onClose} />
            <m5.Page className={txt + ' sb-page-no-safe-top'}>
                <div className='w-100 h-100 d-flex flex-column text-center px-4' style={{ paddingTop: '5rem' }}>
                    {isVip ?
                        <div className='d-flex flex-column flex-grow-1'>
                            <div className='d-flex flex-column align-items-center justify-content-center flex-grow-1'>
                                <img
                                    src='/img/vip.png'
                                    alt='VIP'
                                    className='mb-3'
                                    style={{ width: '100%', maxWidth: 280, height: 'auto' }}
                                />
                                <h4 className='mb-2'>您已是 VIP</h4>
                                <div className='mb-3'>感謝您的支持！</div>
                            </div>
                            <div className='text-muted text-center mt-auto pb-3' style={{ fontSize: '0.72rem', lineHeight: 1.5 }}>
                                <div>Google Play 會在到期前 24 小時自動續訂。</div>
                                <div className='mt-2'>
                                    您可在訂閱管理中
                                    <a
                                        rel='noreferrer'
                                        href={subscriptionUrl}
                                        target='_blank'
                                        style={{ textDecoration: 'underline' }}>
                                        取消訂閱
                                    </a>
                                    ，下期不再扣款。
                                </div>
                            </div>
                        </div> :
                        <div className='d-flex flex-column justify-content-center align-items-center flex-grow-1'>
                            <div className='d-flex justify-content-center align-items-center mx-auto mb-3' style={{ width: 128, height: 128 }}>
                                <img
                                    src='/img/newlogo512.png'
                                    alt='新版 App Icon'
                                    style={{ width: 108, height: 108, borderRadius: 24, objectFit: 'cover' }}
                                />
                            </div>
                            <h4 className='mb-3'>支持開發請使用新版『記帳本』</h4>
                            <div className='text-muted'>目前此版本已關閉 VIP 支持。</div>
                            <div className='text-muted mt-2'>新版有更完整的功能並持續增加新功能🎉🎉</div>
                            <div className='text-muted mt-2'>只要登入相同帳號，紀錄都會保留！</div>
                            <div className='mt-4 d-flex justify-content-center'>
                                <a rel='noreferrer' href={upgradeAppUrl} target='_blank' className='btn btn-primary text-white'>
                                    立刻下載
                                </a>
                            </div>
                        </div>
                    }
                </div>
            </m5.Page>
        </>
    )
}

export const AppPopover = React.memo(({ text, onSet }) => {
    let content = text
    if (text != null && text.indexOf('\n') > -1) {
        content = text.split('\n').map((t, i) => (
            <div key={'ap-' + i}>{t}</div>
        ))
    }
    return (
        <m5.Popup
            isOpen={text !== null}
            buttons={[{
                text: '確定',
                handler: onSet
            }]}>
            {content}
        </m5.Popup>
    )
})

export const AnonymousPopover = ({ isOpen, config, onSet, updateConfig }) => {
    const initId = config.im || config.id
    const copy = () => {
        navigator.clipboard.writeText(initId).then(() => {
            mobiscroll.toast({
                message: '複製成功'
            })
        }, (err) => {
            console.error('', err);
        });
        if (window.Stockbook && typeof window.Stockbook.copy === "function") {
            window.Stockbook.copy(initId)
        }
    }

    const importId = () => {
        const im = document.getElementById("anonymousId").value
        if (im) {
            const docRef = db.collection('users').doc(im)
            docRef.get().then((doc) => {
                if (doc.exists) {
                    let oldConfig = doc.data()
                    config = { ...oldConfig, id: initId, im }
                    updateConfig(config)
                    mobiscroll.toast({
                        message: '匯入成功'
                    })

                } else {
                    mobiscroll.toast({
                        message: '匯入失敗 (代碼無效)',
                        color: 'danger'
                    })
                }
            })
        } else {
            mobiscroll.toast({
                message: '匯入失敗 (代碼無效)',
                color: 'danger'
            })
        }

    }

    return (
        <m5.Popup
            isOpen={isOpen}
            buttons={[{
                text: '確認',
                handler: onSet
            }]}
            animation={false}
        >
            <h5>匿名代碼</h5>
            <div className="px-2 text-muted">
                避免換機或其它狀況導致紀錄遺失<br />
                <b>建議登入Google帳戶使用記帳本</b><br />
                或記下代碼：透過匯入代碼還原紀錄
            </div>
            <div className="w-100 d-flex justify-content-start">
                <m5.Input className='my-2 mx-2' inputStyle='outline' defaultValue={initId} />
                <m5.Button className='my-2 px-2' color='secondary' onClick={copy}>複製</m5.Button>
            </div>
            <div className="text-right text-danger px-2">請妥善保管，避免他人使用</div>
            <hr />
            {config && config.im ?
                <div className='text-center'>已使用既有匿名代碼</div> :
                <>
                    <div>使用既有匿名代碼</div>
                    <div className="w-100 d-flex justify-content-start">
                        <m5.Input id="anonymousId" className='my-2 mx-2' inputStyle='outline' />
                        <m5.Button className='my-2 px-2' onClick={importId} >匯入</m5.Button>
                    </div>
                </>

            }
        </m5.Popup>
    )
}

export const RateConfirmPopover = React.memo(({ text, onConfirm, onCancel }) => {
    let content = text
    if (text != null && text.indexOf('\n') > -1) {
        content = text.split('\n').map((t, i) => (
            <div key={'rcp-' + i}>{t}</div>
        ))
    }
    return (
        <m5.Popup
            animation="pop"
            isOpen={text !== null}
            buttons={[{
                text: '下次再說',
                handler: onCancel,
                cssClass: 'text-secondary'
            }, {
                text: '5星支持',
                handler: onConfirm
            }]}>
            {content}
        </m5.Popup>
    )
})

export const UpgradeConfirmPopover = React.memo(({ text, onConfirm, onCancel }) => {
    let content = text
    if (text != null && text.indexOf('\n') > -1) {
        content = text.split('\n').map((t, i) => (
            <div key={'ucp-' + i}>{t}</div>
        ))
    }
    return (
        <m5.Popup
            animation="pop"
            isOpen={text !== null}
            buttons={[{
                text: '稍後再說',
                handler: onCancel,
                cssClass: 'text-secondary'
            }, {
                text: '立即升級',
                handler: onConfirm
            }]}>
            {content}
        </m5.Popup>
    )
})

const LoginConfirmPopover = ({ text, onConfirm, onCancel }) => {
    let content = text
    if (text != null && text.indexOf('\n') > -1) {
        content = text.split('\n').map((t, i) => (
            <div key={'lcp-' + i}>{t}</div>
        ))
    }
    return (
        <m5.Popup
            isOpen={text !== null}
            buttons={[{
                text: '取消',
                handler: onCancel
            }, {
                text: '重新登入',
                handler: onConfirm,
                cssClass: 'text-danger'
            }]}>
            {content}
        </m5.Popup>
    )
}

const LogoutConfirmPopover = ({ text, onConfirm, onCancel }) => {
    let content = text
    if (text != null && text.indexOf('\n') > -1) {
        content = text.split('\n').map((t, i) => (
            <div key={'lcp-' + i}>{t}</div>
        ))
    }
    return (
        <m5.Popup
            isOpen={text !== null}
            buttons={[{
                text: '取消',
                handler: onCancel
            }, {
                text: '登出',
                handler: onConfirm,
                cssClass: 'text-danger'
            }]}>
            {content}
        </m5.Popup>
    )
}

const DeleteConfirmPopover = ({ text, onConfirm, onCancel }) => {
    let content = text
    if (text != null && text.indexOf('\n') > -1) {
        content = text.split('\n').map((t, i) => (
            <div key={'lcp-' + i}>{t}</div>
        ))
    }
    return (
        <m5.Popup
            isOpen={text !== null}
            buttons={[{
                text: '取消',
                handler: onCancel
            }, {
                text: '刪除',
                handler: onConfirm,
                cssClass: 'text-danger'
            }]}>
            {content}
        </m5.Popup>
    )
}

class ListItem extends React.Component {
    render() {
        return (
            <li className="d-flex justify-content-between">
                {
                    this.props.item.id === -1 ?
                        <div>
                            <span className="font-weight-bold">{this.props.item.title}</span>
                            <span className="badge badge-danger ml-2">NEW</span>
                        </div> : this.props.item.id === 0 ?
                            <div>
                                <span className="font-weight-bold">{this.props.item.title}</span>
                                <span className="badge badge-warning ml-2">VIP</span>
                            </div> :
                            <span>{this.props.item.title}</span>
                }
                <span className="text-muted">{this.props.item.des}</span>
            </li>)
    }
}

export const ListNote = ({ text, style }) => (
    <div className="text-muted text-right p-1 px-3"
        style={{ ...style, fontSize: '0.75rem' }}>{text}</div>
)

const DealerItem = ({ item }) => {
    const { id, name, dc, mfr, mf } = item

    return (
        <li name={id}>{name || dealersOptions.filter(o => (o.id === id))[0].name} {dc}
            <span className="ml-2">零股最低 {mfr ? mfr : 20} 元</span>
            {mf && <span className="ml-2">整股最低 {mf ? mf : 20} 元</span>}
        </li>
    )
}

const findLast = (arr, test) => {
    return arr.reduceRight((found, item) => {
        if (found !== null) return found;
        if (test(item)) return item;
        return null;
    }, null);
}

const DealerSelect = ({ show, setShow, dealers, setEditDealer }) => {
    const [dealer, setDealer] = useState(null)
    //自訂名稱
    const custDealer = findLast(dealers, d => d.id.indexOf('sb') === 0);
    const idx = custDealer ? parseInt(custDealer.id.replace('sb', '')) + 1 : 1
    let newOptions = [...dealersOptions]
    if (!custDealer) {
        newOptions = [{ id: 'sb' + String(idx).padStart(2, '0'), name: '自訂' }, ...dealersOptions]
    }

    const select = (ev) => {
        const seletedDealer = newOptions.filter(o => o.id === ev.target.value)[0]
        setDealer(seletedDealer)
    }

    const btns = [
        {
            text: '取消',
            cssClass: 'float-left',
            handler: () => { setShow(false) }
        },
        {
            text: '確定',
            handler: () => { setEditDealer(dealer) }
        }]

    return (
        <m5.Popup display="bottom"
            isOpen={show}
            maxHeight={'50%'}
            buttons={btns}>
            {newOptions.filter(o => dealers.map(d => d.id).indexOf(o.id) === -1)
                .map(o => (
                    <mobiscroll.Radio key={o.id} name="dealer"
                        value={o.id} checked={dealer && dealer.id === o.id} onChange={select}>
                        {o.name}
                    </mobiscroll.Radio>)
                )}
        </m5.Popup>)
}

const Config = React.memo(({ config, onSet, onClose, setAppLoading, afterSave }) => {
    const [loading, setLoading] = useState(false)
    const dealerRef = useRef(JSON.stringify(config.dealers))
    const [currConfig, setCurrConfig] = useState(config)
    const [editDealer, setEditDealer] = useState(null)
    const [showOptions, setShowOptions] = useState(false)
    const { appContext, dispatchAppContext } = useContext(AppContext)
    const { theme } = appContext
    const txt = theme === 'dark' ? 'text-light' : 'text-dark'
    const [page, setPage] = useState(null)
    const [alertTxt, setAlertTxt] = useState(null)
    const [confirmTxt, setConfirmTxt] = useState(null)
    const [confirmLogoutTxt, setConfirmLogoutTxt] = useState(null)
    const [confirmDeleteTxt, setConfirmDeleteTxt] = useState(null)
    const [displayCols, setDisplayCols] = useState(localStorage.getItem(configCols) ?
        localStorage.getItem(configCols) : 'def')
    const [displayPrice, setDisplayPrice] = useState(localStorage.getItem(configPrice) ?
        localStorage.getItem(configPrice) : 'buyin')
    const [displayRevenue, setDisplayRevenue] = useState(localStorage.getItem(CONFIG_REVENUE) ?
        localStorage.getItem(CONFIG_REVENUE) : 'def')
    const [multiSync, setMultiSync] = useState(localStorage.getItem(configMultiSync) === 'true'
        && currConfig.vip !== '' && currConfig.vip !== undefined)
    const [anonymousOpen, setAnonymousOpen] = useState(false)

    useEffect(() => {
        const isModified = () => {
            const { name, target, dealers, im, isAnonymous } = currConfig
            return (
                name !== config.name ||
                target !== config.target ||
                JSON.stringify(dealers) !== dealerRef.current ||
                isAnonymous !== config.isAnonymous ||
                im !== config.im
            )
        }

        const save = () => {
            if (currConfig.ct === undefined) {
                //紀錄首次使用時間
                currConfig.ct = getTimestamp()
            }
            currConfig.version = 'Lite-' + version
            db.collection('users').doc(currConfig.id).set(currConfig)
                .then(() => {
                    if (currConfig.im !== config.im && currConfig.im)
                        afterSave(currConfig.im, 'cache') //重新載入持股資料
                    onSet(currConfig)
                    console.log("Document successfully written!");
                }).catch((error) => {
                    console.error("Error writing document: ", error);
                });
        }

        if (isModified()) {
            const saveId = setTimeout(() => { save() }, 888)
            return () => { clearTimeout(saveId) }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currConfig, config])

    const stages = {
        right: [{
            percent: -25,
            color: 'red',
            text: '刪除',
            confirm: true,
            action: (event, inst) => {
                inst.remove(event.target, null, () => {
                    // console.log(event)
                    removeDealer(event);
                });
                return false;
            }
        }],
        left: [{
            percent: 25,
            color: 'green',
            text: '編輯',
            action: (event, inst) => {
                setEditDealer(currConfig.dealers[event.index])
                //setEditDealer(inst[])
            }
        }]
    };

    const signIn = () => {
        setLoading(true)
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.currentUser.linkWithPopup(provider)
            .then((result) => {
                setLoading(false)
                var user = result.user;
                const u = {
                    id: user.uid,
                    name: user.displayName || currConfig.name,
                    email: user.email,
                    photoUrl: user.photoURL,
                    isAnonymous: user.isAnonymous
                }
                setCurrConfig({ ...currConfig, ...u })
                //console.log("Anonymous account successfully upgraded", user);
            }).catch((error) => {
                setLoading(false)
                if (error.code === 'auth/credential-already-in-use') {
                    setConfirmTxt('此帳號已有使用過記帳本\n請確認是否要執行重新登入？\n目前的資料可能無法復原！')
                }
                //console.log("Error upgrading anonymous account", error);
                //console.debug(error)
            })
    }

    const signOut = () => {
        setConfirmLogoutTxt('確定要登出目前帳號？')
    }

    const changeName = (ev) => {
        const newConfig = {
            ...currConfig,
            name: ev.target.value
        }
        setCurrConfig(newConfig)
    }

    const changeTarget = (value) => {
        const newConfig = {
            ...currConfig,
            target: parseInt(value * 10000)
        }
        setCurrConfig(newConfig)
    }

    const updateDealer = (dealer, keepOpen) => {
        let newDealers = [...currConfig.dealers]
        if (newDealers.filter(d => d.id === dealer.id).length === 0) {
            newDealers.push(dealer)
        } else {
            newDealers = newDealers.map(d => {
                if (d.id === dealer.id) {
                    return dealer
                }
                return { ...d }
            })
        }
        const newConfig = {
            ...currConfig,
            dealers: newDealers
        }
        setCurrConfig(newConfig)
        if (keepOpen)
            setEditDealer({ ...newDealers.filter(d => d.id === dealer.id)[0] })
        else
            setEditDealer(null)
        setShowOptions(false)
    }

    const removeDealer = (ev) => {
        let newDealers = [...currConfig.dealers]
        newDealers.splice(ev.index, 1)
        const newConfig = {
            ...currConfig,
            dealers: newDealers
        }
        setCurrConfig(newConfig)
    }

    const onCloseAlert = () => {
        setAlertTxt(null)
    }

    const onCancelLogin = () => {
        setConfirmTxt(null)
    }

    const onConfirmLogin = () => {
        firebase.auth().signOut().then(() => {
            //onClose()
        }).catch((error) => {
            // An error happened.
        });
    }

    const onCancelLogout = () => {
        setConfirmLogoutTxt(null)
    }

    const onConfirmLogout = () => {
        firebase.auth().signOut().then(() => {
            //onClose()
        }).catch((error) => {
            // An error happened.
        });
        if (window.Stockbook && typeof window.Stockbook.signOut === "function")
            window.Stockbook.signOut()
    }

    const tapInfo = (ev) => {
        switch (info[ev.index].id) {
            case -1:
                setPage('upgrade')
                break;
            case 0:
                if (window.Stockbook) {
                    if (typeof window.Stockbook.chkVIP === "function")
                        window.Stockbook.chkVIP(currConfig.vip)
                }
                setPage('vip')
                break;
            case 1:
                if (window.Stockbook && typeof window.Stockbook.shareApp === "function") {
                    window.Stockbook.shareApp()
                } else {
                    setAlertTxt('此功能限 App 使用')
                }
                break;
            case 2:
                if (window.Stockbook && typeof window.Stockbook.rateApp === "function") {
                    window.Stockbook.rateApp()
                } else {
                    setAlertTxt('此功能限 App 使用')
                }
                break;
            case 4:
                setPage('qa')
                break;
            default:
                break;
        }
    }

    const changeDisplayCols = (ev, inst) => {
        const value = inst.getVal()
        setDisplayCols(value)
        localStorage.setItem(configCols, value)
        dispatchAppContext({ type: "SET_CONFIG_COLS", cols: value })
    }

    const changeDisplayPrice = (ev, inst) => {
        const value = inst.getVal()
        setDisplayPrice(value)
        localStorage.setItem(configPrice, value)
        dispatchAppContext({ type: "SET_CONFIG_PRICE", price: value })
    }

    const changeDisplayRevenue = (ev, inst) => {
        const value = inst.getVal()
        setDisplayRevenue(value)
        localStorage.setItem(CONFIG_REVENUE, value)
        dispatchAppContext({ type: "SET_CONFIG_REVENUE", revenue: value })
    }

    const changeDarkMode = (ev) => {
        const newTheme = ev.target.checked ? 'dark' : 'light';
        if (window.Stockbook && window.Stockbook.setTheme) {
            window.Stockbook.setTheme(newTheme)
        }
        setAppLoading(true)
        setLoading(true)
        setTimeout(() => {
            setAppLoading(false)
            setLoading(false)
        }, 888)
        dispatchAppContext({ type: "TOGGLE_DARK_MODE" })
    }

    const changeMultiSync = (ev) => {
        const { checked } = ev.target
        setMultiSync(checked)
        localStorage.setItem(configMultiSync, checked)
        dispatchAppContext({ type: "SET_CONFIG_MULTI_SYNC", multiSync: checked })
    }

    const closePage = () => {
        setPage(null)
    }

    const showAnonymous = () => {
        setAnonymousOpen(true)
    }

    const closeAnonymous = () => {
        setAnonymousOpen(false)
    }

    const deleteAccount = () => {
        setConfirmDeleteTxt('確定要刪除帳號與紀錄？\n此操作將無法復原資料')
    }

    const onConfirmDelete = () => {
        db.collection('deletedUsers').add({ user: currConfig.id, dt: getTimestamp(), isAnonymous: currConfig.isAnonymous }).then(() => {
            onConfirmLogout()
        }).catch((error) => {
            console.error("Error add deletedUsers document: ", error);
        })
    }

    const onCancelDelete = () => {
        setConfirmDeleteTxt(null)
    }

    const { name, target, dealers, isAnonymous } = currConfig

    const notVIP = currConfig.vip === '' || currConfig.vip === undefined
    const bgColor = theme === 'dark' ? '#0F0F0F' : '#ffffff'
    const txtColor = notVIP ? theme === 'dark' ? '#545454' : '#AAAAAA' : theme === 'dark' ? '#FFFFFF' : '#000000'

    return (
        <>
            {page ?
                {
                    qa: <QA theme={theme} onClose={closePage} />,
                    dividend: <DividendCalendar theme={theme} onClose={closePage} />,
                    vip: <VIPPage theme={theme} onClose={closePage} vip={currConfig.vip} />,
                    upgrade: <UpgradePage
                        theme={theme}
                        onClose={closePage}
                        userId={currConfig.im || currConfig.id}
                        isAnonymous={currConfig.isAnonymous}
                    />
                }[page] :
                <>
                    <Nav theme={theme} title="設定" onBack={onClose} />
                    {loading ?
                        <div className="d-flex justify-content-center mt-4">
                            <div className={'spinner-border ' + txt} role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div> :
                        <m5.Page className='sb-page-no-safe-top'>
                            <AppPopover text={alertTxt} onSet={onCloseAlert} />
                            <LoginConfirmPopover text={confirmTxt} onConfirm={onConfirmLogin} onCancel={onCancelLogin} />
                            <LogoutConfirmPopover text={confirmLogoutTxt} onConfirm={onConfirmLogout} onCancel={onCancelLogout} />
                            <DeleteConfirmPopover text={confirmDeleteTxt} onConfirm={onConfirmDelete} onCancel={onCancelDelete} />
                            <div className="mbsc-form-group-title">個人資料</div>
                            <mobiscroll.Input
                                placeholder="輸入名稱" value={name}
                                onChange={changeName}
                                errorMessage={name ? '' : '請設定名稱'}>
                                顯示暱稱
                            </mobiscroll.Input>
                            <mobiscroll.Slider
                                value={target / 10000}
                                data-val="left"
                                onChange={changeTarget}
                                data-tooltip="true"
                                max={1000}
                                step={10}
                                data-template="{value}萬"
                            >
                                目標庫存
                            </mobiscroll.Slider>
                            {isAnonymous &&
                                <>
                                    <div className="px-3 mt-1">
                                        <m5.Button className='mbsc-btn-block' onClick={showAnonymous} color='secondary' >
                                            使用匿名代碼
                                        </m5.Button>
                                    </div>
                                    <AnonymousPopover isOpen={anonymousOpen} config={currConfig} onSet={closeAnonymous} updateConfig={setCurrConfig} />
                                </>
                            }
                            <div className="mbsc-form-group-title">交易券商及手續費折數</div>
                            {dealers.length === 0 ?
                                <div className="px-3 text-danger">請至少設定一個券商</div> :
                                <>
                                    <mobiscroll.Listview
                                        itemType={DealerItem}
                                        data={dealers}
                                        stages={stages}
                                        theme="ios"
                                        themeVariant="light"
                                        lang="zh"
                                    />
                                    <ListNote text="向右滑編輯 向左滑刪除" />
                                </>
                            }
                            <DealerEditor dealer={editDealer} onCancel={() => { setEditDealer(null) }} onSet={updateDealer} />
                            {showOptions &&
                                <DealerSelect show={showOptions} setShow={setShowOptions} dealers={dealers} setEditDealer={setEditDealer} />
                            }
                            <div className="m-0 px-3 d-flex justify-content-between">
                                {(dealers.length < dealersLimit && !showOptions) &&
                                    <mobiscroll.Button onClick={() => { setShowOptions(true) }}>新增我的券商</mobiscroll.Button>}
                            </div>
                            <div className="mbsc-form-group-title">顯示設定</div>
                            <mobiscroll.Switch
                                checked={'dark' === theme}
                                onChange={changeDarkMode}>
                                深色主題
                            </mobiscroll.Switch>
                            <m5.Select label="顯示欄位"
                                display="bottom"
                                value={displayCols}
                                setText="確定"
                                cancelText="取消"
                                onChange={changeDisplayCols}
                                data={displayColsOption}>
                            </m5.Select>
                            <m5.Select label="均價定義"
                                display="bottom"
                                value={displayPrice}
                                setText="確定"
                                cancelText="取消"
                                onChange={changeDisplayPrice}
                                data={displayPriceOption}>
                            </m5.Select>
                            <m5.Select label="未實現損益"
                                display="bottom"
                                value={displayRevenue}
                                setText="確定"
                                cancelText="取消"
                                onChange={changeDisplayRevenue}
                                data={displayRevenueOption}>
                            </m5.Select>
                            <div className="mbsc-form-group-title">VIP專屬</div>
                            <mobiscroll.Switch
                                disabled={notVIP}
                                checked={multiSync} onChange={changeMultiSync}>
                                多裝置同步
                            </mobiscroll.Switch>
                            <mobiscroll.Button
                                className={'w-100 m-0 text-left rounded-0 pl-3'}
                                style={{ backgroundColor: bgColor, color: txtColor }}
                                disabled={notVIP}
                                onClick={() => { setPage('dividend') }}
                            >
                                除權息行事曆</mobiscroll.Button>
                            <div className="mbsc-form-group-title">程式資訊</div>
                            <mobiscroll.Listview
                                onItemTap={tapInfo}
                                itemType={ListItem}
                                data={info}
                            />
                            <hr className="m-0" />
                            {isAnonymous ?
                                <>
                                    <div className="px-3 mt-2">
                                        <mobiscroll.Button onClick={signIn} className="md-social-btn mbsc-btn-block" style={{ background: '#d34230', color: '#fff' }}>
                                            <span className="mbsc-ic mbsc-ic-fa-google mbsc-pull-left"></span>
                                            Log in with Google
                                        </mobiscroll.Button>
                                    </div>
                                    <ListNote text="登入後資料可轉移至其他裝置" />
                                </> :
                                <div className="px-3 d-flex justify-content-end">
                                    <button type="button" className="btn btn-danger rounded-pill m-2 py-2 w-25"
                                        onClick={signOut}>
                                        登出
                                    </button>
                                </div>}
                            <div>
                                <button type="button" className="btn btn-link mr-4 text-danger" onClick={deleteAccount}>刪除帳號與紀錄</button>
                            </div>
                        </m5.Page>
                    }
                </>
            }
        </>
    )
})

export default Config